import { PAYCHEX } from '@perpay-web/fintech/constants/partnerOnboardingCodes';
import {
    SIGNUP_FLOW_MARKETPLACE,
    SIGNUP_FLOW_PARTNER_ONBOARDING,
    SIGNUP_FLOW_PAYROLL_PROVIDER_ONBOARDING,
} from '@perpay-web/fintech/constants/signupFlowTypes';
import {
    SIGNUP,
    sortSignupSteps,
} from '@perpay-web/fintech/constants/steps/signupSteps';
import {
    getPartnerCode,
    isInPartnerOnboardingFlow,
} from '@perpay-web/fintech/selectors/ui/partnerOnboarding';

export const getSignupRequirements = (state) =>
    sortSignupSteps(state.ui.signup.signupRequirements);

export const getIsSignupComplete = (state) =>
    getSignupRequirements(state).length === 0;

export const getInitialRequirements = (state) =>
    sortSignupSteps(state.ui.signup.initialRequirements);

export const getIsSignupInitiallyComplete = (state) =>
    getInitialRequirements(state).length === 0;

export const getSignupStep = (state) =>
    getSignupRequirements(state)[0] || SIGNUP;

export const getSignupLoading = (state) => state.ui.signup.signupLoading;

export const getSignupErrors = (state) => state.ui.signup.errors;

export const getJobUUID = (state) => state.ui.signup.jobUUID;

export const getPhoneStep = (state) => state.ui.signup.phoneStep;

export const getSignupFlowType = (state) => {
    if (isInPartnerOnboardingFlow(state)) {
        if (getPartnerCode(state) === PAYCHEX) {
            return SIGNUP_FLOW_PAYROLL_PROVIDER_ONBOARDING;
        }
        return SIGNUP_FLOW_PARTNER_ONBOARDING;
    }
    return SIGNUP_FLOW_MARKETPLACE;
};

export const getPhoneVerificationJustCompleted = (state) =>
    state.ui.signup.phoneVerificationJustCompleted || false;

export const getPayrollProvider = (state) => state.ui.signup.payrollProvider;
